// External
import { useContext, useState } from "react";

// Internal
import SignaturePad from "../UI/SignaturePad";
import AgreementPDF from "../../assets/files/partner-agreement.pdf";
import { requestPartnerAPI } from "../../api/server";
import { AuthContext } from "../../context/auth-context";
import { uploadBase64String } from "../../util/uploadBase64String";
import Heading from "../UI/Heading";
import { MdDownload } from "react-icons/md";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import { UtilityContext } from "../../context/util-context";
import DataContext from "../../context/data-context";
import CreditAppAgreement from "./CreditAppAgreement";
import PartnerAgreement from "../setup/PartnerAgreement";

/** ========================================================================
 * * Sign FAP Agreement Component
 * Renders a form to sign the FAP Agreement.
 * ========================================================================== */

export default function SignFAPAgreement() {
  const { user } = useContext(AuthContext);
  const { fetchData } = useContext(DataContext);
  const { navigate } = useContext(UtilityContext);

  // Initialize States
  const [loading, setLoading] = useState(false);

  // ========================================== SIGN POWER OF ATTORNEY
  const submitHandler = async (signature) => {
    try {
      setLoading(true);
      const signatureURL = await uploadBase64String(
        `partners/${user.uid}/signature`,
        signature
      );
      const response = await requestPartnerAPI("generate-agreement", {
        signature: signatureURL,
      });
      fetchData(() => {
        window.open(response.agreement, "_blank");
        navigate(`/settings`);
        setLoading(false);
      });
    } catch (err) {
      console.error(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="grid gap-4 bg">
      <Heading
        isBackArrow={true}
        title="Sign FAP Agreement"
        description="Please read the Fleet Acquisition Partner Agreement carefully and scroll to the bottom to sign. Once signed, you will be able to download the signed document."
      >
        <a
          href={AgreementPDF}
          download="partner-agreement-template.pdf"
          target="blank"
          rel="noopener noreferrer"
          className="flex items-center p-2 space-x-2 btn-secondary"
        >
          <p className="hidden text-sm text-stone-200 md:block">
            Download Template
          </p>
          <MdDownload className="text-xl text-stone-200" />
        </a>
      </Heading>

      {loading ? (
        <LoadingSpinnerWrapper />
      ) : (
        <div className="h-full px-2 py-4 overflow-scroll border border-yellow-600 rounded-md">
          <div className="grid gap-6">
            <PartnerAgreement />
            <hr className="hr" />
            <SignaturePad setSignature={submitHandler} />
          </div>
        </div>
      )}
    </div>
  );
}
